export default __webpack_public_path__ + "static/media/left5.669d4da3.png";